import { useMemo } from "react";
import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

export function useCurrentUserGrants() {
  const [direct, directResult] = useQuery(queries.currentUserDirectGrants());
  const [groups, groupsResult] = useQuery(queries.currentUserGroupGrants());
  const grants = useMemo(
    () => [
      ...(direct ?? []),
      ...(groups ?? []).flatMap((g) => g.roleGrantsAsPrincipal),
    ],
    [direct, groups]
  );
  const complete =
    directResult.type === "complete" && groupsResult.type === "complete";
  return [grants, { type: complete ? "complete" : "unknown" }] as const;
}
